<template>
    <div class="tab-content-wrap">

        <edit-switch :tab="selectedTab" :edit="editEnabled" v-on:toggleEdit="handleToggleEdit" />
        <div class="tab-content" style="overflow-x: visible;">
            <page-title title="Certificates" v-if="editEnabled" />

            <div class="row" v-if="editEnabled">
                <div class="col-6 ml-0 mr-0">
                    <label>Copy course certificate configuration</label>
                    <div class="item-content">
                        <div class="access-sg text clearfix">
                            <div>
                                <certificate-actions :edit="editEnabled" v-on:handlePreview="previewCertificate" v-on:handleAddProperty="addCertificateProperty" />

                                <!--certificate property-->
                                <div v-for="config in courseDetails.certificateProperties" class="card m-2 p-2" style="border: 1px solid #282D69; padding-bottom: 0!important; box-shadow: #282D69 5px 5px 15px;">

                                    <certificate-property :initialConfig="config" :edit="editEnabled" :initialCourseDetails="courseDetails" :facilitated="course.isFacilitated" v-on:handleDelete="deleteCertificateProperty" v-on:handleFileChange="fileChange" v-on:updatePreview="updatePreview" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <conditional-text :condition="courseDetails.certificateProperties.length < 1" text="No fields yet" />
                </div>
                <div class="col-6 ml-0 mr-0">
                    <div class="container-fluid" v-show="editEnabled">
                        <certificate-fields v-on:updatePreview="updatePreview" :edit="editEnabled" :initialCourseDetails="courseDetails" :initialCourses="courses" />
                        <!--update this on change-->
                        <div class="container-fluid d-flex justify-content-center">
                            <iframe v-show="preview" id="frame-preview-certificate" class="mt-3" width="600" height="775"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="row p-3">
                <div class="col-12">
                    <div class="title">
                        <h2>Certificate Preview</h2>
                    </div>
                    <div v-if="hasCertificate" class="d-flex justify-content-center">
                        <iframe id="frame-preview-certificate-start" width="600" height="775"></iframe>
                    </div>
                    <conditional-text :condition="!hasCertificate" text="No certificate to preview" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "CertificatePage",
        props: ["tab", "edit", "initialCourseDetails", "initialCourse", "parentThis", "initialCourses"],
        data() {
            return {
                selectedTab: this.tab,
                editEnabled: this.edit,
                courseDetails: this.initialCourseDetails,
                course: this.initialCourse,
                courses: this.initialCourses,
                parent: this.parentThis,
                preview: true,
                lastCertificateCourseId: null
            };
        },
        computed: {
            hasCertificate() {
                var has = (this.courseDetails.certificateProperties && this.courseDetails.certificateProperties.length > 0) || this.lastCertificateCourseId;
                return has;
            }
        },
        watch: {
            initialCourseDetails: function (newVal, oldVal) {
                this.courseDetails = newVal;

            },
            courseDetails: function (newVal, oldVal) {
                console.log("Course details changed", newVal);
            },
            initialCourse: function (newVal, oldVal) {
                this.course = newVal;
            },
            initialCourses: function (newVal, oldVal) {
                this.courses = newVal;
            },
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
                if (newVal && this.hasCertificate) {
                    this.updatePreview();
                }
                if (oldVal && this.hasCertificate) {
                    this.setCertificatePreview();
                }
            },
            tab: function (newVal, oldVal) {
                this.selectedTab = newVal;
            },
            parentThis: function (newVal, oldVal) {
                this.parent = newVal;
            },
        },
        methods: {
            async getCertificate(id) {
                if (id && id !== null) {
                    var courseCertificate = await this.web("/courses/certificate/" + id, "Getting certificate");
                    this.courseDetails.certificateOrientation = courseCertificate.certificateOrientation;
                    this.courseDetails.certificateProperties = courseCertificate.certificateProperties;
                }
                else {
                    this.courseDetails.certificateProperties = [];
                }
            },
            async updatePreview() {
                if (this.editEnabled) {
                    var id = this.courseDetails.certificateCourseCopyId;
                    if (id !== null && id !== undefined) {
                        //check that previous id not the same as current
                        if (id !== this.lastCertificateCourseId) {
                            this.lastCertificateCourseId = id;
                            await this.getCertificate(id);
                        }
                        await this.previewCertificate();
                    }
                    else {
                        if (id !== this.lastCertificateCourseId && id !== undefined) {
                            this.lastCertificateCourseId = null;
                            this.courseDetails.certificateProperties = [];
                        }
                        await this.previewCertificate();
                    }
                }
            },
            handleToggleEdit() {
                this.$emit("toggleEdit");
            },
            fileChange(target, course, type) {
                this.$emit("fileChanged", target, course, type);
            },
            async setCertificatePreview() {
                var pdfBytes = await this.parent.generateCertificate(this.course, this.courseDetails);
                var frameTarget = $("#frame-preview-certificate-start");
                $(frameTarget).attr("src", URL.createObjectURL(new Blob([pdfBytes], {
                    type: "application/pdf"
                })));
            },
            async previewCertificate() {
                this.preview = true;
                var pdfBytes = await this.parent.generateCertificate(this.course, this.courseDetails);
                var target = $("#frame-preview-certificate");
                $(target).attr("src", URL.createObjectURL(new Blob([pdfBytes], {
                    type: "application/pdf"
                })));
                $(target).show();
            },
            addCertificateProperty: function (type) {
                if (!this.courseDetails.certificateProperties) {
                    this.courseDetails.certificateProperties = [];
                }

                this.courseDetails.certificateProperties.unshift({
                    type: "CourseName",
                    fileName: null,
                    text: "",
                    y: 0,
                    x: 0,
                    fontSize: 20,
                    centerHorizontally: false,
                    width: 50,
                    height: 50,
                    customType: 'text',
                    customText: '',
                    colorHex: ''
                });
                this.updatePreview();
            },
            deleteCertificateProperty(parent, target) {
                this.$emit("handleDelete",'Certificate Property' ,{ parent, target });
                this.updatePreview();
            }
        },
        mounted() {
            if (this.courseDetails.certificateProperties && this.courseDetails.certificateProperties.length > 0) {
                if (!this.editEnabled) {
                    this.setCertificatePreview();
                }
                else {
                    this.updatePreview();
                }
            }
        }
    }
</script>